module.exports = __webpack_public_path__ + "img/Product.8297644a.svg";